import { SIGN_OUT } from 'state-management/constants/signOut';

export function signOut(redirectTo = '/') {
    return {
        type: SIGN_OUT,
        redirectTo,
    };
}
